import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    border: `1px solid ${palette.text.hint}`,
    borderRadius: 6,
    background: 'rgba(33, 33, 33, 0.03)',
    padding: spacing(2),
    marginTop: spacing(2),
    marginBottom: spacing(3)
  },
  inputContainer: {
    padding: spacing(1),
    '&:first-child': {
      paddingLeft: 0
    },
    '&:last-child': {
      paddingRight: 0
    }
  },
  input: {
    background: palette.white.main
  },
  setFromMeta: {
    textTransform: 'capitalize',
    backgroundColor: 'rgb(0 112 189)',
    color: 'white'
  },
  addAttrBtn: {
    textTransform: 'capitalize',
    background: palette.white.main,
    width: 250,
    marginRight: 8
  },
  autofillBtn: {
    width: 250,
    marginLeft: 8
  },
  removeBtn: {
    textTransform: 'capitalize',
    height: '80%',
    marginTop: 5
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))
